import {useQuery} from '@tanstack/react-query'
import {useServices} from '@/services/context'

const SYNC_RUNS_KEY = 'inbound-connectors-sync-runs'
const SYNC_RECORDS_KEY = 'inbound-connectors-sync-records'

export function useSyncRuns(id: string | undefined, queryParams: string) {
    const services = useServices()
    return useQuery({
        queryKey: [SYNC_RUNS_KEY, id, queryParams],
        queryFn: () => services.inboundConnectors.syncRuns(id!, Object.fromEntries(new URLSearchParams(queryParams))),
        enabled: !!id,
    })
}

/**
 * Fetches the run-detail DTO for a single sync run. Unlike {@link useSyncRuns}, the
 * detail response includes {@code errorLogIds} — composite refs to {@code error_logs}
 * rows recording per-record failures from this run. The list endpoint returns these
 * empty to avoid an N+1 query across the page.
 */
export function useSyncRunDetail(connectorId: string | undefined, runId: string | undefined) {
    const services = useServices()
    return useQuery({
        queryKey: [SYNC_RUNS_KEY, connectorId, runId, 'detail'],
        queryFn: () => services.inboundConnectors.syncRunDetail(connectorId!, runId!),
        enabled: !!connectorId && !!runId,
    })
}

export function useSyncRecords(
    connectorId: string | undefined,
    runId: string | undefined,
    queryParams: string,
    pollingIntervalMs?: number,
) {
    const services = useServices()
    const refetchInterval = pollingIntervalMs && pollingIntervalMs > 0 ? pollingIntervalMs : false
    return useQuery({
        queryKey: [SYNC_RECORDS_KEY, connectorId, runId, queryParams],
        queryFn: () => services.inboundConnectors.syncRecords(connectorId!, runId!, Object.fromEntries(new URLSearchParams(queryParams))),
        enabled: !!connectorId && !!runId,
        refetchInterval,
    })
}
